module.exports = __webpack_public_path__ + "files/443a5f506d0f5a939ffdec5d4e441031.png";